module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/marketing/marketing.component.scss
// module id = ./src/app/pages/client/marketing/marketing.component.scss
// module chunks = main